function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(160.74)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  className: "logo",
  d: "m-178.78 80.8v5.8c11.6 4.7 24.7 4.7 36.3 0v-5.8c-11.5 5.4-24.8 5.4-36.3-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo",
  d: "m-160.63 0c-25.572 0-46.25 20.2-46.25 45.1 0 16.1 8.6906 30.9 22.675 38.8v-6.3c-10.788-7.3-17.281-19.5-17.281-32.5 0-22 18.38-39.8 40.856-39.8s40.856 17.9 40.856 39.8c0 13-6.493 25.3-17.381 32.6v6.3c13.985-8 22.775-22.8 22.775-38.9 0-24.9-20.678-45.1-46.25-45.1z",
  strokeWidth: 0.99946
}), /*#__PURE__*/React.createElement("path", {
  className: "logo",
  d: "m-173.68 58 1.7-4.8 7.3 6.7 4.1-6.5 4.1 6.5 7.3-6.7 1.7 4.8c1.5-0.5 3.1-1.1 4.5-1.8 0.3-0.1 0.4-0.5 0.3-0.7l-15.6-43.4c-0.3-0.9-1.3-1.6-2.3-1.6-1.1 0-2 0.7-2.4 1.6l-15.5 43.4c-0.2 0.3 0 0.6 0.3 0.7 1.4 0.7 2.9 1.3 4.5 1.8zm13.1-36.5 9.5 26.3-4.2 3.8-5.3-8.3-5.3 8.3-4.2-3.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo",
  d: "m-178.78 60.6v5.8c1.8 0.8 3.6 1.4 5.5 1.9v1.7c0 0.2 0.2 0.5 0.4 0.5 1.4 0.4 2.9 0.7 4.3 1 0.2 0 0.3-0.1 0.5-0.2 0.1-0.1 0.2-0.2 0.2-0.4v-1.4c2.4 0.4 4.8 0.5 7.3 0.6 6.2 0 12.3-1.2 18.1-3.6v-5.8c-11.5 5.5-24.8 5.5-36.3 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo",
  d: "m-178.78 70.7v5.8c1.8 0.7 3.6 1.4 5.5 1.9v1.7c0 0.2 0.2 0.4 0.4 0.5 1.4 0.4 2.9 0.7 4.3 0.9 0.2 0.1 0.3 0 0.5-0.1 0.1-0.1 0.2-0.3 0.2-0.4v-1.5c2.4 0.4 4.8 0.5 7.3 0.6 6.2 0 12.3-1.2 18.1-3.6v-5.8c-11.5 5.5-24.8 5.5-36.3 0z"
}));

function SvgAwebaseLogoWhiteSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 .22302 92.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwebaseLogoWhiteSmall);
export default __webpack_public_path__ + "static/media/awebase-logo-white-small.380d40b2.svg";
export { ForwardRef as ReactComponent };